<pl-container>
  <div *ngIf="isLoading" class="flex h-full w-full items-center justify-center">
    <pl-loader />
  </div>
  <div class="flex flex-col gap-8 py-4" *ngIf="!isLoading && mockBlockLifeChanges">
    <h1 class="px-4 md:px-0">{{ 'profile.lifechanges' | translate }}</h1>
    <p class="px-4 md:px-0">{{ 'life_changes.view_and_revise_lifechanges' | translate }}</p>
    <pl-block-life-changes [(ngModel)]="mockBlockLifeChanges" />
  </div>
</pl-container>
